module.exports = __webpack_public_path__ + "static/media/ray-vega-quartet-hotel-vt.53c02bda.jpg";